/* eslint-disable dot-notation */
import { Order } from 'blockly/javascript'

export function registerLoopGenerators(gen) {
  gen.forBlock['loop_repeat'] = function (block, generator) {
    const times = block.getFieldValue('TIMES') || 10
    const branch = generator.statementToCode(block, 'DO') || ''
    return `for (let i = 0; i < ${times}; i++) {\n${branch}}\n`
  }

  gen.forBlock['loop_forever'] = function (block, generator) {
    const branch = generator.statementToCode(block, 'DO') || ''
    return `while (true) {\n${branch}yieldFrame();\n}\n`
  }

  gen.forBlock['loop_wait'] = (block) => {
    const seconds = block.getFieldValue('SECONDS') || 1
    return `await sleep(${seconds});\n`
  }

  gen.forBlock['loop_wait_until'] = function (block, generator) {
    const cond = generator.valueToCode(block, 'COND', Order.NONE) || 'false'
    return `await waitUntil(() => ${cond});\n`
  }
}
